// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__QJake","section-1":"payroll_section-1__p6y+b","content":"payroll_content__RCoy-","section-2":"payroll_section-2__OgEco"};